module.exports = __webpack_public_path__ + "img/leartask.415211da.png";